import { useEffect, useRef, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Sidebar } from "./components/Sidebar";
import { Topbar } from "./components/Topbar";
import { cn } from "../utils/cn";

const SIDEBAR_KEY = "kameti.sidebar.collapsed";

export function AppLayout() {
  const [collapsed, setCollapsed] = useState<boolean>(() => {
    try {
      return localStorage.getItem(SIDEBAR_KEY) === "1";
    } catch {
      return false;
    }
  });
  const [mobileOpen, setMobileOpen] = useState(false);
  const mainRef = useRef<HTMLElement>(null);
  const { pathname } = useLocation();
  // Return the content area to the top whenever the route changes, including
  // browser back/forward, so a new screen never opens mid-scroll.
  useEffect(() => {
    mainRef.current?.scrollTo({ top: 0 });
  }, [pathname]);

  useEffect(() => {
    try {
      localStorage.setItem(SIDEBAR_KEY, collapsed ? "1" : "0");
    } catch {
      // ignore storage errors
    }
  }, [collapsed]);

  const toggleCollapsed = () => setCollapsed((v) => !v);

  return (
    <div className="flex h-screen w-full overflow-hidden bg-background-50 text-foreground-900 print:h-auto print:overflow-visible">
      {/* Desktop sidebar */}
      <div className={cn("hidden h-full flex-none transition-all duration-200 md:block no-print", collapsed ? "w-16" : "w-60")}>
        <Sidebar collapsed={collapsed} onToggle={toggleCollapsed} />
      </div>

      {/* Mobile drawer */}
      {mobileOpen ? (
        <div className="fixed inset-0 z-50 md:hidden no-print">
          <div className="absolute inset-0 bg-foreground-950/40" onClick={() => setMobileOpen(false)} />
          <div className="absolute inset-y-0 left-0 w-64">
            <Sidebar collapsed={false} onToggle={() => { }} onNavigate={() => setMobileOpen(false)} />
          </div>
        </div>
      ) : null}

      <div className="flex h-full min-w-0 flex-1 flex-col print:h-auto print:overflow-visible">
        <Topbar onMenuClick={() => setMobileOpen(true)} collapsed={collapsed} onToggleSidebar={toggleCollapsed} />
        <main className="flex-1 overflow-y-auto print:overflow-visible print:h-auto" ref={mainRef}>
          <div key={pathname} className="p-4 md:p-6 print:p-0">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}